import { render } from "./IconEyeCancel.vue?vue&type=template&id=672b4604"
const script = {}

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__